import { CosmosDialogService, CosmosDialogStyle } from "@/core/services/cosmos-dialog.service";
import { CLUSTER_COLUMNS } from './clusters.const';
import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ClusterDataSource } from '@/modules/clusters/clusters.datasource';
import {
  ClusterFragment,
  ClustersGQL,
} from '@/core/graphql/graphql';
import {
  ClusterDetailsModalComponent,
} from "@/modules/clusters/components/cluster-details-modal/cluster-details-modal.component";
import { filter, first } from "rxjs/operators";
import { ClusterDialog } from "@/modules/clusters/components/cluster-details-modal/cluster-dialog.model";

@Component({
  selector: 'cosmos-clusters',
  templateUrl: './clusters.component.html',
  styleUrls: ['./clusters.component.scss'],
})
export class ClustersComponent implements OnInit {
  public _loading$: Observable<boolean>;
  public readonly _dataSource: ClusterDataSource;
  public readonly _columns = CLUSTER_COLUMNS;

  public constructor(
    private readonly _dialog: CosmosDialogService,
    private readonly _clustersGql: ClustersGQL,
  ) {
    this._dataSource = new ClusterDataSource(_clustersGql);
    this._loading$ = this._dataSource._loading$;
  }

  public ngOnInit(): void {
    this._dataSource.loadData(null);
  }

  public openDetails(data: ClusterFragment): void {
    const dialogRef = this._dialog.open<ClusterDetailsModalComponent, { elementId: number }, ClusterDialog>(ClusterDetailsModalComponent, {
      data: {
        elementId: data.id,
      },
      style: CosmosDialogStyle.Dark,
    });

    dialogRef.afterClosed().pipe(
      first(),
      filter(data => !!data?.refreshData),
    ).subscribe(_ => this._dataSource.loadData(null));
  }
}
